<div class="unsubscribe-container">
    <h2>Enter emails to UnSubscribe </h2>
    <form [formGroup]="unsubscribeForm" (ngSubmit)="onSubmit()">
        <label for="email">Email Address:</label>
        <input type="email" id="email" formControlName="email"
            placeholder="Enter one or more emails, separated by semi colan" />
        <div class="sample-label">
            <strong>Sample:</strong><br />
            Single Email: johndoe&#64;gmail.com<br />
            Multiple Emails: john&#64;example.com;jane&#64;example.com
        </div>
        <div *ngIf="email?.invalid && email?.touched" class="error">
            Valid email is required.
        </div>

        <button type="submit" *ngIf="!submitting">
            Unsubscribe
        </button>
        <button type="submit" [disabled]="submitting" *ngIf="submitting">
            <div class="spinner-border text-warning" role="status">
                <span class="sr-only">Loading...</span>
            </div> Unsubscribing...
        </button>
    </form>

    <div *ngIf="message" class="message">
        {{ message }}
    </div>
</div>